import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/ButtonComponentWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/common/SmallLoader.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/loaders/HighlightLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/navigation/NavBarDynamicShadow.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/quiz/QuizNavButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/quiz/QuizPageContent.tsx");
